import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../services/api.service'
import { environment } from '../../../environments/environment'
import { EcosentinoBanner } from './ecosentino-banner/ecosentino-banner.component'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { SamplesBanner } from './samples-banner/samples-banner.component'
import { CtaBlock } from './cta-block/cta-block.component'
import { HomeBannersComponent } from '../../components/home-banners/home-banners.component';
import { RetailAdvancedBanner } from './retail-advanced-banner/retail-advanced-banner.component'
import { NewsComponent } from './news/news.component'
import { ActivityBlock } from './activity-block/activity-block.component'
import { LoyaltyBlockComponent } from './loyalty-block/loyalty-block.component'
import { BannerWecommerceComponent } from './banner-wecommerce/banner-wecommerce.component'
import { LeadsBlock } from './leads-block/leads-block.component'
import { LeadsBlock2026 } from './leads-block-2026/leads-block-2026.component'
import { Kblevel2026Component } from './kblevel-2026/kblevel-2026.component'
import { VirtualVisitBanner } from './virtual-visit-banner/virtual-visit-banner.component'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { Router } from '@angular/router'

const LOYALTY_NO_SALES_POPUP_SESSION_KEY = 'loyaltyNoSalesPopupShownThisSession'
const LOYALTY_NO_SALES_POPUP_MAX_TIMES = 3

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    imports: [EcosentinoBanner,CommonModule,TranslateModule,SamplesBanner,RetailAdvancedBanner, HomeBannersComponent,CtaBlock,NewsComponent,ActivityBlock,LoyaltyBlockComponent,BannerWecommerceComponent,LeadsBlock,LeadsBlock2026,Kblevel2026Component,VirtualVisitBanner,ConfirmModalComponent],
    standalone: true,
})
export class HomeComponent implements OnInit {
    userInfo: UserInfo
    protected readonly environment = environment
    public isLoyalty2026Active: boolean = environment.loyalty2026
    public loyaltyNoSalesPopupOpen: boolean = false

    constructor(private api: ApiService, private router: Router) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            this.checkLoyaltyNoSalesPopup(userInfo)
        })
    }

    private checkLoyaltyNoSalesPopup(userInfo: UserInfo): void {
        if (!userInfo?.loyaltyLevel) return

        const loyaltyLevel = userInfo.loyaltyLevel?.toUpperCase()
        const isEligible = ['PREMIUM', 'ELITE'].includes(loyaltyLevel)
        const hasNoSales = !userInfo.ytdSales || userInfo.ytdSales === 0
        const hasSalesModule = ['RETAIL'].includes(userInfo.accountType?.toString() ?? '')

        if (!isEligible || !hasNoSales || !hasSalesModule) return

        if (sessionStorage.getItem(LOYALTY_NO_SALES_POPUP_SESSION_KEY)) return

        this.api.getLoyaltyNoSalesPopupCount().subscribe(({ count }) => {
            if (count < LOYALTY_NO_SALES_POPUP_MAX_TIMES) {
                this.loyaltyNoSalesPopupOpen = true
                sessionStorage.setItem(LOYALTY_NO_SALES_POPUP_SESSION_KEY, 'true')
                this.api.incrementLoyaltyNoSalesPopupCount().subscribe()
            }
        })
    }

    closeLoyaltyNoSalesPopup(): void {
        this.loyaltyNoSalesPopupOpen = false
    }

    goToRegisterSalesFromPopup(): void {
        this.loyaltyNoSalesPopupOpen = false
        this.router.navigate(['/new-sales'])
    }

    hasLeadsAcccess(): boolean {
        let hasAccess = false
        if(this.userInfo.mainMenu.items.find((item) => item.code === 'my-leads')) {
            hasAccess = true
        }
        return hasAccess
    }

    hasWeCommerceAccess(): boolean {
        return !!this.userInfo.mainMenu.items.find((item) => item.code === 'we-store')
    }
}
